import { PageComboBoxComponent } from './page-combo-box.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * ページリストを管理するクラス
 *
 * @export PageComboBoxModel
 * @class PageComboBoxModel
 */
export class PageComboBoxModel {

  // ページリスト
  public pageList: Array<any> = new Array<any>();

  public blank: boolean = <boolean>true;                                        // 先頭空白表示
  public allPage: boolean = <boolean>false;                                     // 全ページ
  public notCarrying: boolean = <boolean>false;                                 // 非掲載
  public component: PageComboBoxComponent;                                      // コンボボックスインスタンス
  public completeUpdateFlg: boolean = <boolean>false;                           // コードリスト取得完了
  public setPageId: string = <string>'';                                        // 初期設定ページID値

  public iPageView: IPageView = null;                                           // ページ情報再表示用インターフェース
  public setPageNum: string = <string>'';                                       // 初期設定ページ
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  //  オーダーコード(voの値)
  public orderCode: string = <string>'';
  public MediumType: string = <string>'';
  public coopCode: string = <string>'';

  /**
   * ページリストを更新する
   *
   * @param serverData ページリスト取得データ
   */
  public updatePageList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;


    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankPageObject('', ''));
      index += 1;
    }
    // 全ページ
    if (this.allPage) {
      tempDataList.splice(index, 0, this.getBlankPageObject('*', '全ページ'));
      index += 1;
    }
    // 非掲載
    if (this.notCarrying) {
      tempDataList.splice(index, 0, this.getBlankPageObject('-', '非掲載'));
      index += 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      const pageNum: string =
        typeof tempDataList[index].PageNum === 'number' ? tempDataList[index].PageNum.toString() : tempDataList[index].PageNum;
      tempDataList[index].PageNum =
        PlessViewUtilsSub.padding(pageNum, 3, '0', 1);
      tempDataList[index].PageNumInfo =
        tempDataList[index].PageNum + ':' + tempDataList[index].PageInfo;
    }

    this.pageList = tempDataList;
    this.completeUpdateFlg = true;
    if (this.setPageNum !== '') {
      this.component.updateSelectedPage_byPageNum();
    }
  }

  /**
   * 空白のページオブジェクトを取得する
   *
   * @private
   * @param {string} pageId
   * @param {string} pageInfo
   * @returns {object}
   * @memberof PageComboBoxModel
   */
  private getBlankPageObject(pageId: string, pageInfo: string): object {
    const ob: any = {};
    ob.PageId = pageId;
    ob.PageNum = '';
    ob.PageInfo = pageInfo;
    ob.OrderCode = '';
    ob.MediumType = '';
    ob.CoopCode = '';
    ob.PageTemplateId = '';
    ob.PositionX = '';
    ob.PositionY = '';
    ob.SizeW = '';
    ob.SizeH = '';
    ob.DivX = '';
    ob.DivY = '';
    ob.PageNumInfo = pageInfo;

    return ob;
  }

}
